<!--  -->
<template>
  <div>
    <div class="headerbox" v-if="articles.length>0">
      <img
        :src="`${global.remoteIp}/uploads/${articles[0].picsrc}`"
        class="bg"
      />
      <div class="topBox">
        <div style="display: flex; padding: 0 15px">
          <div class="L">
            <img src="/static/images_m/ss.png" /><input
              name=""
              type="text"
              placeholder="请输入您要搜索的课程"
            />
          </div>
          <div class="R"><img src="/static/images_m/sc.png" /></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data() {
    return {
      articles: [],
      global,
    };
  },
  props: {
    plates: Array,
  },
  mounted() {
    let strplate = "";
    for (var i = 0; i < this.plates.length; i++) {
      if (this.plates[i].name == "新闻动态") {
        strplate = this.plates[i]._id;
      }
    }
    this.$axios
      .get(`/api/articles?plateid=${strplate}&page=1&limit=3&sort=-createdAt`)
      .then((res) => {
        if (res.data) {
          this.articles = res.data.data;
        }
      });
  },
  methods: {
   
  },
};
</script>
<style lang="scss" scoped>
    @import "@/assets/css/style_Phone.scss";
</style>
